import React from 'react';
import { motion } from 'framer-motion';
import { Brain, AlertTriangle, UserMinus, Activity } from 'lucide-react';
const attempts = [{
  icon: Brain,
  title: 'La Lógica',
  desc: "Darle explicaciones lógicas falla porque su corteza prefrontal está 'desconectada' durante el colapso."
}, {
  icon: AlertTriangle,
  title: 'La Amenaza',
  desc: 'Las promesas de premios o castigos solo añaden más ruido a un cerebro que ya está desbordado.'
}, {
  icon: UserMinus,
  title: 'El Aislamiento',
  desc: "El 'tiempo fuera' o dejarlo solo aumenta el cortisol y empeora drásticamente la crisis sensorial."
}, {
  icon: Activity,
  title: 'Tu Propio Estrés',
  desc: 'Tu tensión se transmite directamente a él, creando un círculo vicioso de tensión física imposible de romper.'
}];
export function FailedAttempts() {
  return <section className="bg-[#f0e9df] py-20 px-6" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-16">
            Por qué lo que has intentado hasta ahora no funciona
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-17">
            No es tu culpa. Hemos sido educadas para manejar berrinches, no
            sobrecargas neurológicas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-18">
          {attempts.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-white/50 flex gap-4 items-start" data-id="element-19">
              <div className="bg-copper/10 p-3 rounded-lg shrink-0" data-id="element-20">
                <item.icon className="w-6 h-6 text-copper" data-id="element-21" />
              </div>
              <div data-id="element-22">
                <h3 className="text-xl font-serif font-bold text-navy mb-2" data-id="element-23">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-24">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}